import { ACTION } from './envelop_actions';

const initialState = {
  heatDissipationList: [],
  heatDissipationListLoading: false,
  solarAbsorptanceList: [],
  solarAbsorptanceLoading: false,
  errorMessage: null,
  envelopTypeList: [
    { id: 'wall', name: 'wall' },
    { id: 'roof', name: 'roof' },
  ]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_HEAT_DISSIPATION}_PENDING`:
      return {
        ...state,
        heatDissipationListLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST_HEAT_DISSIPATION}_FULFILLED`:
      return {
        ...state,
        heatDissipationListLoading: false,
        heatDissipationList: action.payload,
      };
    case `${ACTION.LIST_HEAT_DISSIPATION}_REJECTED`:
      return {
        ...state,
        heatDissipationListLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.LIST_SOLAR_ABSORPTANCE}_PENDING`:
      return {
        ...state,
        solarAbsorptanceLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST_SOLAR_ABSORPTANCE}_FULFILLED`:
      return {
        ...state,
        solarAbsorptanceLoading: false,
        solarAbsorptanceList: action.payload,
      };
    case `${ACTION.LIST_SOLAR_ABSORPTANCE}_REJECTED`:
      return {
        ...state,
        solarAbsorptanceLoading: false,
        errorMessage: action.payload,
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/references/envelop_reducer.js